import { guess } from "web-audio-beat-detector";

const audioContext = new window.AudioContext();

function fileToArrayBuffer(file: File): Promise<ArrayBuffer> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result as ArrayBuffer);
    };

    reader.onerror = () => {
      reject(new Error("Failed to read file."));
    };

    reader.readAsArrayBuffer(file);
  });
}

function arrayBuffToAudioBuff(file: File): Promise<AudioBuffer> {
  return new Promise((resolve, reject) => {
    fileToArrayBuffer(file)
      .then((arrayBuffer: ArrayBuffer) => {
        // Do something with the arrayBuffer
        audioContext.decodeAudioData(
          arrayBuffer,
          function (buffer) {
            // Resolve the promise with the audio buffer
            resolve(buffer);
          },
          function (error) {
            // Reject the promise if there is an error
            reject(error);
          }
        );
      })
      .catch((error) => {
        console.error(error);
      });
  });
}

export const getBpm = async (file: File): Promise<number> => {
  try {
    const buffer: AudioBuffer = await arrayBuffToAudioBuff(file);
    const { bpm } = await guess(buffer);
    return bpm;
  } catch (error) {
    console.error("BPM detection in determineReturnBpm func:", error);
    throw error;
  }
};

export const determineSetBpm = async (
  file: File,
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void,
  setBpmLoading: (value: React.SetStateAction<boolean>) => void
): Promise<void> => {
  try {
    setBpmLoading(true);
    const bpm = await getBpm(file);
    setFieldValue("bpm", bpm);
    setFieldValue("title", file.name);
  } catch (error) {
    console.error("BPM detection in determineSetBpm func:", error);
    setFieldValue("bpm", 0);
  } finally {
    setBpmLoading(false);
  }
};
